export const routes = [
  {
      name: "About",

      subRoutes: [
        {
          name: "History",
          link: "/about/history",
        },
        {
          name: "Facilities",
          link: "/about/facilities",
        },
        {
          name: "Traditions",
          link: "/about/traditions",
        },
      ],
    },
    {
      name: "Government",

      subRoutes: [
        {
          name: "Core Team",
          link: "/government/coreteam",
        },
        {
          name: "Cabinet",
          link: "/government/cabinet",
        },
        {
          name: "Court",
          link: "/government/court",
        },
        {
            name: "Representatives",
            link: "/government/representatives",
          },
          {
            name: "View Budget",
            link: "https://docs.google.com/spreadsheets/d/10bPS_hfMFgPNqtVTNi5MADesJCjsC5ISHOo67IgopD0/edit?gid=1961358824#gid=1961358824",
          },
          {
            name: "View Constitution",
            link: "/images/general/Wiess%20Constitution.pdf",
            newTab: true,
            // link: "https://docs.google.com/document/d/1qbvMy553nreKAKAUgoLXazVCsHW0O-9FT_FoGfq4PbM/edit",
          },
          {
            name: "View Bylaws",
            link: "https://drive.google.com/file/d/1pXYt4FJOnhtMkgAAG6dxhF3o1sOqSGO7/view",
          },
      ],
    },
    {
      name: "Resources",
  
      subRoutes: [
        {
          name: "Academics",
          link: "/resources/academics",
        },
        {
          name: "Associates",
          link: "/resources/associates",
        },
        {
          name: "Health & Wellbeing",
          link: "/resources/health",
        },
        {
            name: "Diversity & Inclusion",
            link: "/resources/diversity",
        },
        {
          name: "Housing & Dining",
          link: "/resources/housingdining",
        },
        // {
        //   name: "Designs",
        //   link: "https://drive.google.com/drive/folders/0B52XkHoVvpYhcXhDbGoxb0tjbUE?usp=sharing",
        // },
        {
          name: "Rice-Wide",
          link: "https://docs.google.com/spreadsheets/d/14kvozYUheCTkH-QqxSWfO8OMQrILdgr7cW3wF2ePQJs/edit?gid=1352693617#gid=1352693617",
        },
      ],
    },
    {
      name: "New Students",
      link: "/newstudents",
    },
    {
        name: "Income Accessibility",
    
        subRoutes: [
          // {
          //   name: "Guidelines",
          //   link: "https://drive.google.com/file/d/0BwCbCY3Ekm3dRkpsT3had1ZPdjhTcXV3YUtOTG9KSzlQcU44/view",
          // },
          {
            name: "Request Form",
            link: "https://docs.google.com/forms/d/e/1FAIpQLSfCl-qLM0OpvyL0C0sQ-OZOR8v30Q9LZQlxciGvNiCAY7DwBA/viewform",
          },
        ],
    },
    {
        name: "Forms",
    
        subRoutes: [
          {
            name: "Reserve Room",
            link: "https://docs.google.com/forms/d/e/1FAIpQLSdA-cPoab2-_cpES7NmltroDcQkY-fBpPoTH1exmP-LCf9YOg/viewform?c=0&w=1",
          },
          {
            name: "Submit Agenda Item",
            link: "https://docs.google.com/forms/d/e/1FAIpQLSd3Bt0phHh3IRZpMOd0XPB6n5Dprb5PZOq8wv9DP_J1M319uA/viewform?usp=sharing&ouid=103710458526261299487",
          },
          {
            name: "Submit Snaps",
            link: "https://docs.google.com/forms/d/e/1FAIpQLSeM0TXR4lgaVbQLMMgYctN6Bat7wOxtpUt0sdH0kgZu3L5I7Q/viewform?usp=sharing&ouid=103710458526261299487",
          },
          {
            name: "Budget Request",
            link: "https://docs.google.com/forms/d/e/1FAIpQLSehOsZVYlFoLNFQQNzBeVvHGKvEUPleSjVOiESzAT_Fbfag5A/viewform",
          },
          {
            name: "Turn in Receipts",
            link: "https://docs.google.com/forms/d/e/1FAIpQLSeXsr5CQ7kXs6A2j_Ahj_fGwB3h5y9q9WmFj0lhBvD9Mkm8aw/viewform",
          },
          // {
          //   name: "Court Infractions Form",
          //   link: "https://docs.google.com/forms/d/e/1FAIpQLSes8Z8fq0mSqAZdWntODAKnE58MJYnmwbgk8aBEhamRHf5Adg/viewform",
          // },
          {
            name: "All Forms",
            link: "/forms",
          },
        ],
    },
  ];